import { render, staticRenderFns } from "./Picking.vue?vue&type=template&id=2d4d438e&"
import script from "./Picking.vue?vue&type=script&lang=js&"
export * from "./Picking.vue?vue&type=script&lang=js&"
import style0 from "./Picking.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports